<template>
<div class="rightSide">
  <div @click="goPage">政<br/>策<br/>法<br/>规</div>
<!--  <div v-for="(item, page) in buttonList" class="rightSide-box" :class="{'line': page < (buttonList.length-1)}" @click="buttonClick(item)">-->
<!--    <img :src="item.icon" alt="" style="width: 20px;height: 18px"/>-->
<!--    <div style="color: #fff;font-size: 14px;margin-top: 5px">{{ item.name }}</div>-->
<!--  </div>-->
  <div class="dialog" v-if="dialogFlag">
    <div class="close" @click="dialogFlag = false"><i class="el-icon-close"></i></div>
    <div class="title">{{ title }}</div>
    <div class="content" v-if="dialogType" style="font-size: 30px">{{ content }}</div>
    <img src="static/qrCode.png" v-if="!dialogType" alt="" style="width: 200px;height: 200px"/>
  </div>
</div>
</template>

<script>
export default {
  name: "rightSide",
  data(){
    return {
      buttonList: [
        {name: "注册体验", icon: "static/right-side1.png",},
        {name: "电话咨询", icon: "static/right-side2.png",},
        {name: "微信咨询", icon: "static/right-side3.png",},
      ],
      dialogFlag: false,
      title: "联系电话",
      content: "15864739180",
      dialogType: true
    }
  },
  methods: {
    buttonClick(item){
      if(item.name === '注册体验'){
        window.open('https://chem.oneplant.com.cn/#/register',  "_blank")
      }else if(item.name === '电话咨询'){
        this.title = "联系电话"
        this.content = "15864739180"
        this.dialogType = true
        this.dialogFlag = true
      }else if(item.name === '微信咨询'){
        this.title = "微信添加"
        this.content = "13066666666"
        this.dialogType = false
        this.dialogFlag = true
      }
    },
    goPage(){
      this.$router.push('/gardenOfKnowledge')
    },
  }
}
</script>

<style scoped lang="scss">
.rightSide{
  width: 47px;
  height: 99px;
  position: fixed;
  right: 0;
  top: 50%;
  background: #0E54D8 ;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  color: #fff;
  .rightSide-box{
    width: 70px;
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .line{
    border-bottom: 1px #6c98ff solid;
  }
  .dialog{
    width: 300px;
    height: 300px;
    background: #2e79ff;
    position: absolute;
    right: 86px;
    border-radius: 5px;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .close{
      position: absolute;
      right: 5px;
      top: 5px;
      cursor: pointer;
    }
    .title{
      font-weight: 600;
      margin-bottom: 10px;
      font-size: 26px;
    }
  ;
  }
}
</style>